import request from "../../../../utils/request";

export const saveProduct = async (product) => {
    const response = await request.post('/productCatalog', product);
    return response.data.id; 
  };

  export const changeProduct = async (productId,productData) => {
    const response = await request.put(`/productCatalog/${productId}`,productData);
    return response.data.id; 
  };
  
  export const deleteProduct = async (productId) => {
    const response = await request.delete(`/productCatalog/${productId}`);
    return response.data.id; 
  };


export const saveOffering = async (offering) => {
    const response = await request.post('/productCatalog/offerings', offering);
    return response.data.id; 
  };

  export const changeOffering = async (offeringId,offeringData) => {
    const response = await request.put(`/productCatalog/offerings/${offeringId}`,offeringData);
    return response.data.id; 
  };
  
  export const deleteOffering = async (offeringId) => {
    const response = await request.delete(`/productCatalog/offerings/${offeringId}`);
    return response.data.id; 
  };

  // CRUD Service Groups
  export const saveServiceGroup = async (serviceGroup) => {
    const response = await request.post('/productCatalog/service-groups', serviceGroup);
    return response.data.id; 
  };

  export const changeServiceGroup = async (serviceGroupId,serviceGroupData) => {
    const response = await request.put(`/productCatalog/service-groups/${serviceGroupId}`,serviceGroupData);
    return response.data.id; 
  };
  
  export const deleteServiceGroup = async (serviceGroupId) => {
    const response = await request.delete(`/productCatalog/service-groups/${serviceGroupId}`);
    return response.data.id; 
  };
  // CRUD to save service in service groups
  export const saveService = async (service) => {
    const response = await request.post(`/productCatalog/offerings/${service.offeringId}/services`, service);
    return response.data.id;
  };
  export const changeService = async (serviceId,serviceData) => {
    const response = await request.put(`/productCatalog/services/${serviceId}`,serviceData);
    return response.data.id; 
  };
  
  export const deleteService = async (serviceId) => {
    const response = await request.delete(`/productCatalog/services/${serviceId}`);
    return response.data.id; 
  };

  // Save Service in Offering
  export const saveServiceInOffering = async (service) => {
    const response = await request.post(`/productCatalog/offerings/${service.offeringId}/services`, service);
    return response.data.id;
  };

  export const saveQuantity = async (quantityData) =>{
    const response = await request.post(`/productCatalog/services/${quantityData.serviceId}/quantity`,quantityData)
    return response.data.id;
  }
  
  export const changeQuantity = async (quantityId,quantityData) =>{
    const response = await request.put(`/productCatalog/quantity/${quantityId}`,quantityData);
    return response.data.id;
  }

  export const deleteQuantity = async (quantityId) =>{
    const response = await request.delete(`/productCatalog/quantity/${quantityId}`);
    return response.data.id;
  }
  
 export const saveQuestion = async (question) => {
    const response = await request.post(`/productCatalog/services/${question.serviceId}/questions`, question);
    return response.data.id;
  };

  export const changeQuestion = async (questionId,questionData) => {
    const response = await request.put(`/productCatalog/questions/${questionId}`,questionData);
    return response.data.id; 
  };
  
  export const deleteQuestion = async (questionId) => {
    const response = await request.delete(`/productCatalog/questions/${questionId}`);
    return response.data.id; 
  };
  
  export const saveOption = async (questionId,option) => {
    const response = await request.post(`/productCatalog/questions/${questionId}/options`, option);
    return response.data.id; 

  };

  export const changeOption = async (optionId,optionData) => {
    const response = await request.put(`/productCatalog/options/${optionId}`,optionData);
    return response.data.id; 
  };

  export const deleteOption = async (optionId) => {
    const response = await request.delete(`/productCatalog/options/${optionId}`);
    return response.data.id; 
  };

  export const saveOptionPricing = async (optionId,pricingData) => {
    const response = await request.post(`/productCatalog/options/${optionId}/pricing`, pricingData);
    return response.data.id; 

  };

  export const changeOptionPricing = async (pricingData) => {
    const response = await request.put(`/productCatalog/pricing/${pricingData.id}`,pricingData);
    return response.data.id; 
  };

  export const deleteOptionPricing = async (pricingId) => {
    const response = await request.delete(`/productCatalog/pricing/${pricingId}`);
    return response.data.id; 
  };
  
